import { useCompoundBody } from "@react-three/cannon";
import { useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Group, MeshBasicMaterial } from "three";
import { useDragConstraint, ObjectProps, Box } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const navigate = useNavigate();
  
  const materials = useMemo(() => {
    const baseMaterial = new MeshBasicMaterial({color: '#523a32'});
    
    return [
      baseMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
    ];
  }, []);
  const [ref] = useCompoundBody(() => ({
    mass: 1,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { type: 'Box', position: [0, 0, 0], args: [1, 0.025, 0.7], mass: 0.7,  },
      { type: 'Box', position: [0, 0.0175, 0.025], args: [0.975, 0.025, 0.6], mass: 0.3,  },
    ], 
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  const handlePointerEnter = () => { document.body.style.cursor = 'pointer'; };
  const handlePointerLeave = () => { document.body.style.cursor = 'default'; };
  const handleClick = () => {
    document.body.style.cursor = 'default';
    navigate('/CardCase');
  };
  return (
    <group
      ref={ref}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      onClick={handleClick}
      {...bind}
    >
      <Box position={[0, 0, 0]} args={[1, 0.025, 0.7]} material={materials} isMeshStandardMaterial={false} />
      <Box position={[0, 0.0175, 0.025]} args={[0.975, 0.025, 0.6]}  material={materials} isMeshStandardMaterial={false} />
    </group>
  );
};
